
import { Form , Field, ChildForm } from '../form/form';
import { FormData } from '../form/formData';
import { SelectOption, Vo } from '../form/types';
import { Validators } from '@angular/forms'
import { ServiceAgent} from '../form/serviceAgent';

export class CieStudentDetailForm extends Form {
	private static _instance = new CieStudentDetailForm();

	public static getInstance(): CieStudentDetailForm {
		return CieStudentDetailForm._instance;
	}

	constructor() {
		super();
		this.fields = new Map();
		this.controls = new Map();
		this.opsAllowed = {get: true, filter: true};
	}

	public getName(): string {
		 return 'cieStudentDetail';
	}
}


export class CieStudentDetailFd extends FormData {
	constructor(form: CieStudentDetailForm, sa: ServiceAgent) {
		super(form, sa);
	}
	/**  this form has no editable fields. data nust be accessed as Vo and not through fd **/
}


export interface CieStudentDetailVo extends Vo {
	cieMarks?: number, 
	effectiveMarks?: number, 
	subjectRegisterId?: number, 
	hasAttendedExam?: boolean, 
	isEligibleToWithdraw?: boolean, 
	hasWithdrawn?: boolean, 
	isAuthorizedAbsence?: boolean, 
	subjectId?: number, 
	studentId?: number, 
	usn?: string, 
	isGraced?: boolean, 
	examMarks?: number, 
	hasAttendanceShortage?: boolean, 
	seasonId?: number, 
	subjectSectionId?: number, 
	department?: string, 
	academicRegulationId?: number, 
	hasCieShortage?: boolean, 
	subjectName?: string, 
	isCondoned?: boolean, 
	overallAttendance?: string, 
	hasAttendedMakeup?: boolean, 
	isEligibleForExam?: boolean, 
	totalAttendance?: number, 
	hasOptedForMakeup?: boolean, 
	isFinalGrade?: boolean, 
	parentId?: number, 
	offeredSubjectId?: number, 
	totalClasses?: number, 
	isCondonable?: boolean, 
	grade?: string, 
	name?: string, 
	instituteId?: number
}
